import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  error: null,

  password_session_id: null,
  password_otp_enable: 0,
};

const adminUpdatePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
    case ActionTypes.UPDATE_PASSWORD_REQUEST:
        return {
            ...state,
            isFetching: true,
            error: null,
        };

    case ActionTypes.UPDATE_PASSWORD_SUCCESS:
        return {
            ...state,
            isFetching: false,
            response: action.payload,

            password_otp_enable: action.payload?.otp_enable || 0,
            password_session_id: action.payload?.session_id || null,
        };

    case ActionTypes.UPDATE_PASSWORD_FAILURE:
        return {
            ...state,
            isFetching: false,
            error: action.payload,
        };

    default:
        return state;
    }
};

export default adminUpdatePasswordReducer;
